import { IconSitemapOutline18 as MermaidIcon } from "nucleo-ui-outline-18"

import type { SlashCommandDefinition } from "../../types"
import { iconClassName } from "../../constants"

export const mermaidCommand: SlashCommandDefinition = {
	key: "mermaid",
	title: "Mermaid diagram",
	icon: <MermaidIcon strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).insertMermaid().run()
	},
	group: "blocks",
	aliases: ["mermaid", "diagram", "flowchart", "chart", "sequence diagram"],
}
